<template>
  <div>
    <app-title>
      Buttons
      <v-btn color="success" @click="$router.go(-1)">Back</v-btn>
    </app-title>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>